
const initState={
    pds:[],
  shoes: [],
  cart:[]
}

const productReducer=(state=initState,action)=>{
switch(action.type){
    case "PROD":
        return{
            ...state,
            shoes:action.payload
        }
    case "PD":
        return{
            ...state,
            pds:action.payload
        }
    case "ADD":
        return{
            ...state,
            cart:action.payload
        }

        default:
            return state
}

}
export default productReducer;





